import { ISvcStatusBadge } from '@solvace/component/svc-status-badge';
import { CategorizedDrillDown } from '@solvace/core/models';

export interface DefectTagDrillDownItem {
  defectTagId: number;
  defectTagUniqueId: number;
  defect: string;
  inclusionDate: Date;
  status: number;
  defectTagStatusId?: number;
  defectTagSubStatusId?: number;
  owners?: any;
  deadline: string;
}

export class DefectTagCategorizedDrillDown implements CategorizedDrillDown<DefectTagDrillDownItem> {
  indicatorEnum: number;
  indicatorItems: DefectTagDrillDownItem[];
}

export enum DefectTagDrillDownStatus {
  PLANNED = 3, // Planejado
  DELAYED = 6, // Planejado
  SOLVED = 2, // Resolvido
}

export const DefectTagDrillDownStatusBadge = <DefectTagDrillDownStatus>(enumDefinition: DefectTagDrillDownStatus): ISvcStatusBadge => {
  switch (enumDefinition) {
    case DefectTagDrillDownStatus.SOLVED:
      return { description: 'Resolvida', type: 'resolved' };
    case DefectTagDrillDownStatus.PLANNED:
      return { description: 'Planejada - No Prazo', type: 'planned-without-delay' };
    case DefectTagDrillDownStatus.DELAYED:
      return { description: 'Planejada - Atrasada', type: 'delayed' };
  }
};

export enum DefectTagDrillDownStatusId {
  PENDING = 1,
  RESOLVED = 2,
  PLANNED = 3,
  CMMS = 4,
  CANCELED = 5,
}

export enum DefectTagDrillDownSubStatusId {
  DEFAULT = 0,
  PLANNED_IN_TIME = 1,
  PLANNED_LATE = 2,
}

export const DefectTagDrillDownStatusIdBadge = (statusId: number, subStatusId?: number): ISvcStatusBadge => {
  switch (statusId) {
    case DefectTagDrillDownStatusId.PENDING:
      return { description: 'Pendente', type: 'pending' };
    case DefectTagDrillDownStatusId.RESOLVED:
      return { description: 'Resolvida', type: 'resolved' };
    case DefectTagDrillDownStatusId.PLANNED:
      return subStatusId === DefectTagDrillDownSubStatusId.PLANNED_LATE
        ? { description: 'Planejada - Atrasada', type: 'delayed' }
        : { description: 'Planejada - No Prazo', type: 'planned-without-delay' };
    case DefectTagDrillDownStatusId.CMMS:
      return { description: 'CMMS', type: 'cmms' };
    case DefectTagDrillDownStatusId.CANCELED:
      return { description: 'Cancelado', type: 'inactive' };
    default:
      return DefectTagDrillDownStatusBadge(statusId);
  }
};
